import { Notification } from './notification.model';

export interface NotificationResponse {
  count: number;
  today?: Notification[];
  lastWeek?: Notification[];
  lastMonth?: Notification[];
  thisMonth?: Notification[];
}